








































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {FileMimeType, Utils} from '@payroll/optimus-common';
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class MemberAccountsGrid extends FeedbackComponent {

  //accountsDetailsReport

  @Prop(Array) memberAccounts!: any;
  @Prop(Array) memberFundTypes!: any;
  @Prop(String) memberPersonalId!: any;
  @Prop(Boolean) enableOptionToDownloadActiveBalanceConfirmation!: boolean;
  @Prop(Boolean) showExtendedDetails!: boolean;
  @Prop(Boolean) showCustomTitle!: boolean;
  @Prop(Boolean) enableAccountSelection!: boolean;
  @Prop(Boolean) dontShowAllowanceAmountSection!: boolean;
  @Prop(Boolean) showLimitedDetails!: boolean;
  @Prop(String) title!: string

  private employee161Report: boolean = false;

  @Action('accountsDetailsReport', StoreNamespace.CUSTOMER_SERVICE) getAccountsDetailsReport: any;
  @Action('showEmployee161Report', StoreNamespace.CUSTOMER_SERVICE) showEmployee161Report: any
  @Action('generateEmployee161Report', StoreNamespace.CUSTOMER_SERVICE) generateEmployee161Report: any

  private columns: GridColumn[] = [];

  mounted() {
    this.initColumns()
    this.initAccountsRows()
    this.showEmployee161Report({
      requestorCallback: this,
      pathVariable: this.memberPersonalId
    })
  }

  onExportClick() {
    this.generateEmployee161Report({
      requestorCallback: this,
      requestBody: {
        fileType: "PDF",
        reportTypeCode: 1,
        idNumber: this.memberPersonalId
      }
    })
  }

  private initLimitedColumns() {
    this.columns.push({property: 'accountNum', header: 'customerService.popup.accountNum'});
    this.columns.push({property: 'fundTypeDesc', header: 'customerService.popup.fundTypeDesc'})
    this.columns.push({property: 'joinDate', header: 'customerService.popup.joinDate'})
    this.columns.push({property: 'employerName', header: 'customerService.popup.employerName'})
    this.columns.push({property: 'accountBalance', header: 'customerService.popup.accountBalance'})
  }

  private initColumns(): void {
    if (this.showLimitedDetails) {
      this.initLimitedColumns()
      return;
    }


    this.columns.push({property: 'accountNum', header: 'customerService.popup.accountNum'});
    this.columns.push({property: 'fundTypeDesc', header: 'customerService.popup.fundTypeDesc'})
    this.columns.push({property: 'fundName', header: 'customerService.popup.fundName'})
    this.columns.push({property: 'joinDate', header: 'customerService.popup.joinDate'})
    this.columns.push({property: 'employerName', header: 'customerService.popup.employerName'})
    this.columns.push({property: 'accountBalance', header: 'customerService.popup.accountBalance'})
    this.columns.push({property: 'allowanceAmount', header: 'customerService.popup.allowanceAmount'})
    this.columns.push({property: 'withdrawableBalance', header: 'customerService.popup.withdrawableBalance'})


    if (this.showExtendedDetails) {
      this.columns.push({property: 'status', header: 'customerService.popup.status'})
      this.columns.push({property: 'employerName', header: 'customerService.popup.employerName'})
      this.columns.push({property: 'accountStatus', header: 'customerService.popup.accountStatus'})
      this.columns.push({
        property: 'lastDepositDateForMember',
        header: 'customerService.popup.lastDepositDateForMember'
      })
      // this.columns.push({property: 'lastDepositDateForEmployer', header: 'customerService.popup.lastDepositDateForEmployer'})
      this.columns.push({property: 'accountClosingDate', header: 'customerService.popup.accountClosingDate'})
      this.columns.push({
        property: 'accumulationManagementFees',
        header: 'customerService.popup.accumulationManagementFees'
      })
      this.columns.push({
        property: 'managementFeesFromDeposits',
        header: 'customerService.popup.managementFeesFromDeposits'
      })
    }

  }

  private initAccountsRows(): void {

    const data = {
      hasMore: false,
      resultCount: this.memberAccounts.length,
      results: this.memberAccounts
    }


    this.$emit('successResults', data)

  }

  onRowClick(row: any) {

    if (row.accountNum && row.accountNum === "סה\"כ") {
      return
    }

    this.$emit('onMemberAccountSelect', row);
  }

  onDownloadDetailsOfAccounts(fundTypeId: number) {

    const body = {
      fundTypeId: fundTypeId,
      memberIdNum: this.memberPersonalId
    }

    this.getAccountsDetailsReport({
      requestorCallback: this,
      requestBody: body
    })
  }

  onSuccess(data: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case "findMembersOrEmployersFor/accountsDetailsReport":
        Utils.downloadFile(data.fileData, data.fileName, FileMimeType.PDF)
        break
      case "findMembersOrEmployersFor/showEmployee161Report":
        this.employee161Report = data.showEmployee161Report
        break
      case "findMembersOrEmployersFor/generateEmployee161Report":
        this.$emit('successExport', data)
        break
    }
  }

};


